import { DataOnlySimPlans } from './data-only-sim-plans'

export default DataOnlySimPlans
